import React from "react";
import { VectorIcon } from "assests/GmsIcons";
import { useState } from "react";
import { RuleSuggestionOptionType } from "../../Pages/DefineModel/model";

export type propType = {
  data: RuleSuggestionOptionType[];
  onClickHandler: Function;
};

const SelectOptionsView = (props: React.PropsWithChildren<propType>) => {
  const [showChild, setShowChild] = useState<any>()

  const handleClick = (propDoc: RuleSuggestionOptionType) => {
    if (showChild === propDoc.id) setShowChild(null)
    else setShowChild(propDoc.id);
    props.onClickHandler(propDoc);
  }

  return (
    <div className="tw-h-[400px] tw-overflow-scroll">
      {props.data.map((propDoc, propIndex) =>
        <div key={propIndex} className="tw-justify-center tw-relative tw-px-2">
          {/* The old row's white ground was a doubled-prefix typo — a dead class
              that never emitted CSS, so rows have always been transparent; the
              surface ground is the first one that actually paints. */}
          <div role="button" data-testid={`selectoptionsview-index-div-1-${propIndex}`} className="tw-cursor-pointer tw-w-[261px] tw-px-2.5 tw-py-0.5 tw-bg-surface hover:tw-bg-surface-hover tw-rounded-tl tw-rounded-tr tw-border tw-border-edge tw-justify-center tw-items-start tw-relative"
            onClick={() => handleClick(propDoc)}>
            {/* icon-follow-ink: VectorIcon hardcodes a #172B4D stroke. */}
            {propDoc?.hasOptions && <p className="tw-float-right tw-pt-4 tw-pr-0 tw-text-ink-secondary icon-follow-ink"><VectorIcon /></p>}
            <div className="tw-self-stretch tw-text-ink tw-text-sm tw-font-medium tw-font-['Noto Sans'] tw-leading-relaxed">{propDoc.label}</div>
            <div className="tw-text-ink-secondary tw-text-xs ">{propDoc.description}</div>
          </div>
          {
            propDoc.child && propDoc.id === showChild ?
            <div className='tw-absolute tw-left-[268px] tw-top-0 tw-z-10'>
              {propDoc.child.map((option, optionId) =>
              (<div role="button" data-testid={`selectoptionsview-index-div-2-${optionId}`} key={option.label} className="tw-w-[100px] tw-h-9  tw-px-5 tw-py-2 tw-bg-surface hover:tw-bg-surface-hover tw-rounded-tl tw-rounded-tr tw-border tw-border-edge tw-justify-start tw-items-center tw-gap-2.5 tw-cursor-pointer"
                onClick={() => {
                  props.onClickHandler(option)
                }}>
                <div className="tw-grow tw-shrink tw-basis-0 tw-text-ink tw-text-sm tw-leading-tight">{option.label}</div>
              </div>
              )
              )}
            </div>
          : null}

        </div>
      )}
    </div>
  );
};

export default SelectOptionsView;
